module.exports = __webpack_public_path__ + "static/media/SizeBadOptimized.4df574d4.jp2";